export default __webpack_public_path__ + "f920b2b8d9adcc319f96c6cd2c1ec299.png";